export const svgResizer = {
  methods: {
    _updateDimensions () {
      this.clientWidth = Math.max(document.getElementById('stiff').clientWidth, 0)
      this.clientHeight = Math.max(document.getElementById('stiff').clientHeight, 0)
    }
  },
  watch: {
    clientWidth: function () {
      this.breakDownVisualization()
      this.setUpVisualization()
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this._updateDimensions,
      {'passive': true})
    })
    this._updateDimensions()
    this.setUpVisualization()
  },
  destroyed () {
    window.removeEventListener('resize', this._updateDimensions)
  }

}



// WEBPACK FOOTER //
// ./src/components/mixins/svgResizer.js